<template>
    <div v-show="showTravelNetwork">
      <hp5-well-primary fluid vertical-padding="lg">
        <div class="travel-network">
          <hp5-heading size-selection="lg" tag-selection="h3">Looking for care while traveling?</hp5-heading>
          <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
          <hp5-semantic size-selection="md">
            This network also includes coverage across the United States through the Far From Home network.</hp5-semantic
          >
          <hp5-spacing-vertical xs="md" sm="md" md="md" large="md" />
          <hp5-button-decorator type="secondary" size="md"
            ><button type="button" v-on:click="travelSearchClick" style="width: 350px;">Search the Far From Home network</button></hp5-button-decorator
          >
        </div>
      </hp5-well-primary>
      <hp5-spacing-vertical xs="lg" sm="lg" md="lg" lg="lg" />
    </div>
</template>
  
<script setup>

      const model = useFCPModel()
      const { profile, isLocalAreaTravelNetwork, plan, searchResults, context, filterContext, hasSearched } = model
      const { filter } = useSearch(model)
      const searchTypeSnapshot = ref('')
      const type = computed(() => context.value.type)
      const isDental = computed(() => searchTypeSnapshot.value == 'dental' || searchTypeSnapshot.value == 'dentist')
  
      /**
       * Take a snapshot of the search type that was used during the most recent search.
       * We don't want the alert to show up or hide by observing the search type in the
       * criteria, or we would see the alert show up  in the UI prior to a search.
       */
      const snapshotSearchType = () => {
        if (type.value) {
          searchTypeSnapshot.value = type.value
        }
      }
  
      watch(searchResults, () => {
        snapshotSearchType()
      })
  
      const showTravelNetwork = computed(() => {
        // if user has ANY travel network = true
        // and is searching out of 5 state region (checked by isLocalArea)
        // and plan is currently NOT their travel network
        // and searchType is not dentist or dental clinic
        if (!isLocalAreaTravelNetwork.value && profile.value.hasTravelNetwork && !plan.value.isTravelNetwork && !isDental.value 
        && hasSearched.value && searchResults.value && searchResults.value.length == 0) return true
        return false
      })
  
      let networkIndex = computed(() => filterContext.value.networkIndex)
  
      const resolvePlans = () => {
        if (profile.value && filterContext.value) {
          const { getPlans } = usePlan(profile.value, filterContext.value)
          return getPlans()
        }
        return []
      }
  
      const plans = ref(resolvePlans())
  
      watch(filterContext, (current, old) => {
        plans.value = resolvePlans()
      })
  
      const travelSearchClick = async () => {
        // find index of the plan that is the travel network
        let index = plans.value.findIndex(element => { 
          if (element.isTravelNetwork == true) { return true }
        })
        networkIndex = ref(index)
        filterContext.value.networkIndex = networkIndex.value
        const digitalData = window.digitalData || []
        const event = 'TravelNetworkSearch_submit'
        digitalData.push({
          eventData: {
            appliedFilters: filterContext.value,
          },
          event: event,
        })
        await filter()
      }
  
      /* adding watcher here for network index change, this would trigger plan change 
      which would allow us to then decide to hide or show benifit level */
      watch(networkIndex, (current, old) => {
        context.value.networkIndex = networkIndex.value
      })
  
</script>
  
<style lang="scss" scoped>
  .travel-network {
    align-items: center;
    justify-content: center;
    text-align: center;
  }
</style>